/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './activateAccount.defs.js'
export { main as default } from './activateAccount.defs.js'
